import { token } from '@atlaskit/tokens';
import styled from 'styled-components';
import { h600, h700 } from 'view/styles/fonts';

export const Container = styled.div`
    > * {
        margin-bottom: ${token('space.300', '24px')};
    }

    > *:last-child {
        margin-bottom: 0;
    }
`;

export const Title = styled.div`
    ${h700};
    margin-bottom: ${token('space.300', '24px')};
`;

export const Subtitle = styled.div`
    ${h600};
`;
